<!--logged out portion-->

<div class="side-container" [class.active]="!loggedIn()">
  <section class="top-side-btn-container">
    <button mat-icon-button color="primary" (click)="toggleDialog()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Back</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/"
    >
      <mat-icon>home</mat-icon>
    </button>
    <div class="side-btn-text">Home</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/register"
    >
      <mat-icon>assignment_ind</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Register</div>
  </section>

  <section class="side-btn-container">
    <button mat-icon-button color="primary" (click)="openLoginDialog()">
      <mat-icon>login</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Login</div>
  </section>


  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/forgot-password"
    >
      <mat-icon>vpn_key</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Forgot password</div>
  </section>

  <section class="side-btn-container">
    <button
    mat-icon-button
    color="primary"
    [matMenuTriggerFor]="aboutMenu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #aboutMenu>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/privacy-policy"
      >
        <span>Privacy policy</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/about"
      >
        <span>About</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/terms-of-service"
      >
        <span>Terms of Service</span>
      </button>
    
    </mat-menu>
    <div class="side-btn-text">About</div>
  </section>


</div>

<!--logged in portion-->
<div class="side-container" [ngClass]="{ active: loggedIn() }">

  <section class="top-side-btn-container">
    <button mat-icon-button color="primary" (click)="toggleDialog()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Back</div>
  </section>

  <section class="side-btn-container">
    <button mat-icon-button color="warn" (click)="logOut()">
      <mat-icon>logout</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Logout</div>
  </section>

  <section class="side-btn-container" *ngIf="isAdmin()">
    <button mat-icon-button color="primary" (click)="toggleDialog()" routerLink="/user-management">
      <mat-icon>groups</mat-icon>
    </button>
    <div class="bottom-side-btn-text">User Management</div>
  </section>

  <section class="side-btn-container" *ngIf="isAdmin()">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/update-password"
      [disabled]="isGuest"
    >
      <mat-icon>lock</mat-icon>
    </button>
    <div class="side-btn-text">Reset password</div>
  </section>

  <section class="side-btn-container" *ngIf="isAdmin()">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/update-email"
      [disabled]="isGuest"

    >
      <mat-icon>email</mat-icon>
    </button>
    <div class="side-btn-text">Update email</div>
  </section>

  <section class="side-btn-container" *ngIf="isAdmin()">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/settings"
      [disabled]="isGuest"
    >
      <mat-icon>credit_card</mat-icon>
    </button>
    <div class="side-btn-text">Settings/Billing</div>
  </section>

  <section class="side-btn-container">
    <button mat-icon-button color="primary" (click)="toggleDialog()" routerLink="/contact">
      <mat-icon>chat</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Contact us</div>
  </section>

  <section class="side-btn-container">
    <button
    mat-icon-button
    color="primary"
    [matMenuTriggerFor]="loggedInAboutMenu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #loggedInAboutMenu>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/privacy-policy"
      >
        <span>Privacy policy</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/about"
      >
        <span>About</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/terms-of-service"
      >
        <span>Terms of Service</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/instructions"
      >
        <span>Instructions</span>
      </button>
    </mat-menu>
    <div class="side-btn-text">About</div>
  </section>
  
  <section class="bottom-side-btn-container" *ngIf="isAdmin()">
    <button mat-icon-button color="warn" (click)="toggleDialog()" routerLink="/account-deletion">
      <mat-icon>delete_forever</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Delete account</div>
  </section>
</div>

<!--mobile menu view logged in-->
<div class="mobile-side-container" [ngClass]="{ active: loggedIn() }">
  <section class="top-side-btn-container">
    <button mat-icon-button color="primary" (click)="toggleDialog()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Back</div>
  </section>

  <section class="side-btn-container">
    <button mat-icon-button color="warn" (click)="logOut()" routerLink="/">
      <mat-icon>logout</mat-icon>
    </button>
    <div class="side-btn-text">Logout</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/"
    >
      <mat-icon>home</mat-icon>
    </button>
    <div class="side-btn-text">Home</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/yard-view"
    >
      <mat-icon>view_list</mat-icon>
    </button>
    <div class="side-btn-text">Yard view</div>
  </section>

  <section class="side-btn-container" *ngIf="isClerk()">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/add-spot"
    >
      <mat-icon>add</mat-icon>
    </button>
    <div class="side-btn-text">Add Yard Spot</div>
  </section>


  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/moves"
    >
      <mat-icon>trending_flat</mat-icon>
    </button>
    <div class="side-btn-text">Moves</div>
  </section>

  <section class="side-btn-container" *ngIf="isClerk()">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/assign-moves"
    >
      <mat-icon>assignment</mat-icon>
    </button>
    <div class="side-btn-text">Assign Moves</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/moves-history"
    >
      <mat-icon>assignment_turned_in</mat-icon>
    </button>
    <div class="side-btn-text">Moves History</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/trailers"
    >
      <mat-icon>local_shipping</mat-icon>
    </button>
    <div class="side-btn-text">Trailers</div>
  </section>

  <section class="side-btn-container" *ngIf="isAdmin()">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/instance-management"
    >
      <mat-icon>group_add</mat-icon>
    </button>
    <div class="side-btn-text">Instance Selection</div>
  </section>

  <section class="side-btn-container" *ngIf="isAdmin()">
    <button mat-icon-button color="primary" [matMenuTriggerFor]="optionMenu">
      <mat-icon>settings</mat-icon>
    </button>
    <mat-menu #optionMenu="matMenu">
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/update-password"
        [disabled]="isGuest"

      >
        <mat-icon>lock</mat-icon>
        <span>Reset password</span>
      </button>

      <button mat-menu-item (click)="toggleDialog()" routerLink="/update-email" [disabled]="isGuest"
      >
        <mat-icon>email</mat-icon>
        <span>Update email</span>
      </button>

      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/feed-back"
        [disabled]="isGuest"

      >
        <mat-icon>chat</mat-icon>
        <span>Feedback</span>
      </button>


    <button
    mat-menu-item
    (click)="toggleDialog()"
    routerLink="/down-loads"
    [disabled]="isGuest"

  >
    <mat-icon>download</mat-icon>
    <span>Downloads</span>
  </button>

    </mat-menu>
    <div class="side-btn-text">Settings</div>
  </section>

  <section class="side-btn-container">
    <button
    mat-icon-button
    color="primary"
    [matMenuTriggerFor]="loggedInAboutMenu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #loggedInAboutMenu>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/privacy-policy"
      >
        <span>Privacy policy</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/about"
      >
        <span>About</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/terms-of-service"
      >
        <span>Terms of Service</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/instructions"
      >
        <span>Instructions</span>
      </button>
    </mat-menu>
    <div class="side-btn-text">About</div>
  </section>

  <section class="bottom-side-btn-container" *ngIf="isAdmin()">
    <button mat-icon-button color="warn" (click)="toggleDialog()" routerLink="/account-deletion">
      <mat-icon>delete_forever</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Delete account</div>
  </section>
</div>

<!-- mobile view not logged in-->
<div class="mobile-side-container" [ngClass]="{ active: !loggedIn() }">
  <section class="top-side-btn-container">
    <button mat-icon-button color="primary" (click)="toggleDialog()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Back</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/"
      >
      <mat-icon>home</mat-icon>
      
    </button>
    <div class="side-btn-text">Home</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/register"
    >
      <mat-icon>assignment_ind</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Register</div>
  </section>

  <section class="side-btn-container">
    <button mat-icon-button color="primary" (click)="openLoginDialog()">
      <mat-icon>login</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Login</div>
  </section>

  <section class="side-btn-container">
    <button
      mat-icon-button
      color="primary"
      (click)="toggleDialog()"
      routerLink="/forgot-password"
    >
      <mat-icon>vpn_key</mat-icon>
    </button>
    <div class="bottom-side-btn-text">Forgot password</div>
  </section>

  <section class="side-btn-container">
    <button
    mat-icon-button
    color="primary"
    [matMenuTriggerFor]="aboutMenu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #aboutMenu>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/privacy-policy"
      >
        <span>Privacy policy</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/about"
      >
        <span>About</span>
      </button>
      <button
        mat-menu-item
        (click)="toggleDialog()"
        routerLink="/terms-of-service"
      >
        <span>Terms of Service</span>
      </button>

      
    </mat-menu>
    <div class="side-btn-text">About</div>
  </section>
</div>
